<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <material-card
      :title="$t('components.contributionscontrol.table.title')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mediation"
    >
      <template v-slot:actions>
        <div style="margin-right:20px">
          <no-autocomplete-textfield
            clearable
            v-model="searchValue"
            :label="$t('components.employers.search_employers_form.title')"
            append-icon="search"
          />
        </div>
      </template>
      <v-card-text>
        <v-container fill-height fluid>
          <v-row justify="center">
            {{ $t("views.balanceview.pager_{0}_{1}", [currentPage, totalPages]) }}
          </v-row>
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            @input="next"
            v-show="false"
          ></v-pagination>

          <v-row justify="center">
            <v-btn
              @click="next(currentPage - 1)"
              text
              :disabled="currentPage === 1"
            >
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <span style="margin-top:8px">
              {{ translate2(pagerItem, "Name") }}
            </span>
            <v-btn
              @click="next(currentPage + 1)"
              text
              :disabled="currentPage === totalPages"
            >
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="12">
              <contribution-terms-table
                :employer="pagerItem"
              ></contribution-terms-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </material-card>
    <error-handler :error="error"></error-handler>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import { ODataProvider, SortDirection } from "pbas-vue-components";
import ContributionsControlEmployersHeaders from "../headers/ContributionsControlEmployers";
import ErrorHandler from "../components/ErrorHandler";
import { translate2 } from "../trans2";
import ContributionTermsTable from "../components/ContributionsControl/ContributionTermsTable.vue";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield.vue";
export default {
  data() {
    return {
      pagerItem: null,
      error: null,
      pagerProvider: undefined,
      loading: false,
      currentPage: 0,
      itemsPerPage: 1,
      pagerFetchResult: {
        count: 0,
      },
      headers: ContributionsControlEmployersHeaders,
      searchValue: undefined,
      searchMonitor: null,
      sortHeader: null
    };
  },
  mixins: [planSetter],
  components: {
    ErrorHandler,
    ContributionTermsTable,
    NoAutocompleteTextfield,
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
    totalPages() {
      return Math.floor(this.pagerFetchResult.count / this.itemsPerPage);
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    searchValue: {
      async handler(v) {
        if (v === null) {
          this.searchValue = undefined;
        }
        if (this.pagerProvider === null || this.pagerProvider === undefined) {
          return;
        }
        const obj = {};
        this.searchMonitor = obj;
        await this.delay(800);
        if (this.searchMonitor !== obj) {
          return;
        }
        this.currentPage = 1;
        this.getPagerItemsAsync();
      },
    },
  },
  methods: {
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    translate2(item, property) {
      return translate2(item, property);
    },
    loadPlanData() {
      this.pagerProvider = new ODataProvider(
        this.$axiosHttp,
        `plans/${
          this.selectedPlan.Id
        }/contributions-control/employers-for-import`,
        this.headers
      );
      this.sortHeader = this.headers.filter(o=>o.title === "globals.name")[0];
      this.currentPage = 1;
      this.getPagerItemsAsync();
    },
    next(page) {
      this.currentPage = page;
      this.getPagerItemsAsync();
    },
    async getPagerItemsAsync() {
      if (this.pagerProvider === undefined || this.pagerProvider === null) {
        return;
      }
      this.loading = true;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const count = this.itemsPerPage;

      try {
        this.fetchingPromise = this.pagerProvider.fetchAsync(
          start,
          count,
           [{header: this.sortHeader, direction:SortDirection.Ascending}],
          this.searchValue
        );
        const localPromise = this.fetchingPromise;

        const result = await localPromise;
        if (localPromise === this.fetchingPromise) {
          this.pagerFetchResult = result;
          this.pagerItem = this.pagerFetchResult.items[0];
        }
        console.log(this.pagerFetchResult);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
